import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile2User = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16006 11.37C9.06006 11.36 8.94006 11.36 8.83006 11.37C6.45006 11.29 4.56006 9.34 4.56006 6.94C4.56006 4.49 6.54006 2.5 9.00006 2.5C11.4501 2.5 13.4401 4.49 13.4401 6.94C13.4301 9.34 11.5401 11.29 9.16006 11.37Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4098 4.5C18.3498 4.5 19.9098 6.07 19.9098 8C19.9098 9.89 18.4098 11.43 16.5398 11.5C16.4598 11.49 16.3698 11.49 16.2798 11.5",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.16021 15.06C1.74021 16.68 1.74021 19.32 4.16021 20.93C6.91021 22.77 11.4202 22.77 14.1702 20.93C16.5902 19.31 16.5902 16.67 14.1702 15.06C11.4302 13.23 6.92021 13.23 4.16021 15.06Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3398 20.5C19.0598 20.35 19.7398 20.06 20.2998 19.63C21.8598 18.46 21.8598 16.53 20.2998 15.36C19.7498 14.94 19.0798 14.66 18.3698 14.5",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgProfile2User;
